<template>
  <div class="card-main">
    <div class="card-content">
      <div>
        <div class="horario-container">
          <span class="horario-text"
            >{{ start_time.slice(0, 5) }} - {{ end_time.slice(0, 5) }} HS</span
          >
        </div>
         <h3 class="titulo-conferencia"><b>{{ name }}</b></h3>
        <div class="publico-container" >
          <span class="publico-label">PÚBLICO: </span>
          <span class="publico-value">{{ audienceTarget }}</span>
        </div>
      </div>

      <div class="acciones">
        <button class="btn-info" @click="onMoreInfoClick">
          Más información
        </button>
        <button
          class="btn-inscripcion"
          :class="{ 'btn-cancelar': isSubscribed }"
          @click="onSubscribeClick"
          v-if="!isRegistrationClosed"
        >
          {{ isSubscribed ? 'Cancelar registro' : 'Registrarse' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, computed } from "vue";
//import { audienceLabels } from "@/utils/audienceLabels";

const emit = defineEmits(["subscribe-click", "more-info-click"]);

const props = defineProps({
  name: String,
  start_time: String,
  end_time: String,
  // audience: Number,
  primaryColor: {
    type: String,
    default: "#57025b",
  },
  audienceTarget: String,
  registrationEndDate: String,
  isSubscribed: {
    type: Boolean,
    default: false,
  },
});

/* const audienceLabel = computed(() => {
  return audienceLabels[props.audience] || 'Desconocido';
}); */

const isRegistrationClosed = computed(() => {
  if (!props.registrationEndDate || !props.start_time) return false;

  try {
    const [rYear, rMonth, rDay] = props.registrationEndDate.split("-");
    const [startHours, startMinutes] = props.start_time.slice(0, 5).split(":");

    const deadlineDate = new Date(
      parseInt(rYear),
      parseInt(rMonth) - 1,
      parseInt(rDay),
      parseInt(startHours),
      parseInt(startMinutes)
    );

    const now = new Date();

    return now > deadlineDate;
  } catch (error) {
    console.error("Error al procesar fechas:", error);
    return false;
  }
});

const onSubscribeClick = () => {
  emit("subscribe-click");
};

const onMoreInfoClick = () => {
  emit("more-info-click");
};
</script>

<style scoped>
.card-main {
  flex: 0 0 65%;
  display: flex;
  flex-direction: column;
  min-height: 400px;
}

.card-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.horario-container {
  margin-bottom: 0.75rem;
}

.horario-text {
  color: #007bff;
  font-size: 1.4rem;
  font-weight: 600;
}

.titulo-conferencia {
  font-size: 1.5rem;
  font-weight: 700;
  color: #2f2d2d;
  margin: 0.75rem 0;
  line-height: 1.3;
}

.publico-container {
  font-size: 1rem;
  margin-top: 1rem;
}

.publico-label {
  font-weight: 600;
  color: #2f2d2d;
}

.publico-value {
  font-weight: 500;
  color: #2f2d2d;
}

.card-header {
  background: v-bind(primaryColor);
  border-radius: 0;
}

.evento-content-card[style*="order: 1"] .card-header {
  border-top-right-radius: 11px;
}

.evento-content-card[style*="order: 0"] .card-header {
  border-top-left-radius: 11px;
}

.name-evento {
  font-family: Inter;
  font-size: 1.5rem;
  font-weight: 700;
  text-align: center;
  margin-bottom: 2.5rem;
  margin-top: 2.5rem;
  color: white;
}

.info-group {
  margin: 1rem 0;
  margin-left: 0;
  display: grid;
  grid-template-columns: 1fr 3fr;
  gap: 0.75rem;
  align-items: center;
}

.label {
  font-size: 1.1rem;
  font-weight: 600;
  text-align: right;
  margin-bottom: 0;
  color: #2f2d2d;
}

.value {
  font-size: 1.1rem;
  font-weight: 500;
  text-align: left;
  padding-left: 0.5rem;
  color: #2f2d2d;
}

.audience-target {
  font-size: 1.1rem;
   word-wrap: break-word; 
  overflow-wrap: break-word; 
  max-height: 100px; 
}

.acciones {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  margin-top: auto;
  padding-top: 0.75rem;
  width: 100%;
  margin-bottom: 12px;
  flex-shrink: 0;
}

button {
  padding: 0.875rem 1.5rem;
  border: none;
  border-radius: 17px;
  font-family: Inter;
  font-weight: 700;
  cursor: pointer;
  width: 100%;
  max-width: 280px;
}

.btn-info {
  background: #ffffff;
  color: #005fa8;
  border: 1.5px solid #005fa8;
}

.btn-inscripcion {
  background: #005fa8;
  color: #ffffff;
}

.btn-cancelar {
  background: #dc3545;
  color: #ffffff;
}

@media (max-width: 1200px) {
  .name-evento {
    font-size: 40px;
  }

  .label {
    font-size: 20px;
  }

  .value {
    font-size: 28px;
  }

  .audience-target {
    font-size: 20px;
  }

  .horario-text {
    font-size: 1.5rem;
  }

  .titulo-conferencia {
    font-size: 1.6rem;
  }

  .publico-container {
    font-size: 1.1rem;
  }
}

@media (max-width: 992px) {
  .name-evento {
    font-size: 36px;
    margin: 1.5rem 0;
  }

  .info-group {
    grid-template-columns: 1fr;
    text-align: center;
  }

  .label {
    text-align: center;
    font-size: 18px;
  }

  .value {
    text-align: center;
    font-size: 22px;
    padding-left: 0;
  }

  .acciones {
    padding-top: 3rem;
    margin-bottom: 30px;
  }

  .audience-target {
    font-size: 18px;
  }

  .card-header {
    border-radius: 0 !important;
  }

  .horario-text {
    font-size: 1.4rem;
  }

  .titulo-conferencia {
    font-size: 1.5rem;
  }

  .publico-container {
    font-size: 1rem;
  }
}

@media (max-width: 768px) {
  .name-evento {
    font-size: 28px;
  }

  .label {
    font-size: 16px;
  }

  .value {
    font-size: 20px;
  }

  button {
    padding: 0.75rem 1.5rem;
    font-size: 14px;
  }

  .audience-target {
    font-size: 16px;
  }

  .horario-text {
    font-size: 1.25rem;
  }

  .titulo-conferencia {
    font-size: 1.3rem;
  }

  .publico-container {
    font-size: 0.95rem;
  }
}

@media (max-width: 480px) {
  .name-evento {
    font-size: 22px;
  }

  .label {
    font-size: 14px;
  }

  .value {
    font-size: 18px;
  }

  button {
    max-width: 250px;
  }

  .audience-target {
    font-size: 14px;
  }

  .horario-text {
    font-size: 1.15rem;
  }

  .titulo-conferencia {
    font-size: 1.2rem;
  }

  .publico-container {
    font-size: 0.9rem;
  }

  .evento-content-card[style*="order: 1"] .card-header {
    border-top-right-radius: 9px;
  }

  .evento-content-card[style*="order: 0"] .card-header {
    border-top-left-radius: 1px;
  }
}
</style>